import { render, staticRenderFns } from "./HomeBoard.vue?vue&type=template&id=55f1ffac&"
import script from "./HomeBoard.vue?vue&type=script&lang=js&"
export * from "./HomeBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports